import { inject, Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private _auth = inject(AuthService);

  canActivate(): boolean {
    if (this._auth.isUserAuthenticated()) {
      return true;
    } else {
      //this._user.clearUser();
      this._auth.logout();
      return false;
    }
  }
}
